<template>
  <div class="row flex-column-reverse flex-lg-row gx-0 gx-lg-64 gx-xl-140">
    <div class="col-12 col-lg-5 offset-lg-1">
      <div class="d-flex flex-column gap-40">
        <div v-if="!!user" class="content">
          <p class="fw-semi h6 mb-24">{{ user.email }}</p>

          <v-change-user-data
            v-if="!!user"
            :locale="locale"
            :trans="trans"
            :user="user"
            @saved="loadUser()">
          </v-change-user-data>

          <v-change-user-password
            v-if="!!user"
            :locale="locale"
            :trans="trans"
            @saved="loadUser()">
          </v-change-user-password>
        </div>

        <slot name="social"></slot>
      </div>
    </div>

    <div class="col-12 col-lg-5 mb-32 mb-lg-0">
      <div class="billing line-decoration d-flex flex-column mb-40 mt-24 mt-lg-0 ">
        <p class="fw-semi h6 mb-24">{{ trans.billingTitle ?? '' }}</p>

        <div id="subscriber-billing-data">
          <v-subscriber-billing :trans="trans"></v-subscriber-billing>
        </div>
      </div>

      <p class="fw-semi h6 mb-24">{{ trans.supportTitle ?? '' }}</p>

      <div class="support d-flex flex-column gap-16">
        <a :href="`mailto:${trans.supportButtonLink}`"
           target="_blank"
           rel="noreferrer"
           :aria-label="trans.supportTitle ?? ''"
           class="btn btn-primary py-12">{{ trans.supportButtonText ?? '' }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@assets/js/front/checkout/api';
import VChangeUserData from './parts/VChangeUserData.vue';
import VChangeUserPassword from './parts/VChangeUserPassword.vue';
import VSubscriberBilling from './VSubscriberBilling.vue';

export default {
  name: 'VSubscriptionPage',
  components: {
    VChangeUserData,
    VChangeUserPassword,
    VSubscriberBilling,
  },
  props: {
    trans: {
      required: true,
    },
    locale: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      disabledButton: false,

      user: {},
    };
  },
  async mounted() {
    await this.loadUser();
  },
  methods: {
    async loadUser() {
      const loggedIn = await api.auth.check();

      if (!!loggedIn) {
        this.user = await api.user.retrieve();
      } else {
        window.location.href = '/';
      }
    },
  },
};
</script>

<style lang="scss">
.passwordButton {
  position: absolute;
  cursor: pointer;
  top: 20%;
  right: 1rem;
  z-index: auto;
  color: white;
  border-radius: 20px;

  &:disabled, &:hover {
    color: gray;
  }
}

input {
  padding-inline: 1rem !important;
}

</style>
